import { render } from "./SelectSubpopulationEdit.vue?vue&type=template&id=040c10a7&scoped=true"
import script from "./SelectSubpopulationEdit.vue?vue&type=script&lang=js"
export * from "./SelectSubpopulationEdit.vue?vue&type=script&lang=js"

import "./SelectSubpopulationEdit.vue?vue&type=style&index=0&id=040c10a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040c10a7"]])

export default __exports__